import React from "react";
import UsageGuideCard from "../usage-guide-card/UsageGuideCard";
import UsageGuideStepProps from "./usage-guide-step-props.interface";
import { ReactComponent as RedBigArrowRightIcon } from "../../../../../assets/icons/red-big-arrow-right-icon.svg";
import { ReactComponent as BigCone } from "../../../../../assets/images/big-cone.svg";

const GuideEnd = ({ handleNextStep, handleClose }: UsageGuideStepProps) => {
  return (
    <div className="step__end">
      <UsageGuideCard handleClose={handleClose} isMainCardType>
        <div className="row">
          <div className="text-content col-md-6">
            <h1>Alright!</h1>
            <p><strong>Congratulations! Now you know this snack!</strong></p>
            <p>
             But this is just an example of what we can do to find custom solutions with a 3D Viewer.  Discover our uni-verse!
            </p>

            <button type="button" onClick={handleNextStep} className="clickable">
              <u>Play with our star S23VI-ALPHA!</u>
            </button>

            <a href="http://www.some-url.com" target="_blank" rel="noreferrer" className="clickable">
              I like It. Let&apos;s talk
              <RedBigArrowRightIcon className="right-arrow" />
            </a>
          </div>
          <div className="col-md-6">
            <BigCone className="side-image"/>
          </div>
        </div>
      </UsageGuideCard>
    </div>
  );
};

export default GuideEnd;
